import {
  primaryElementarySchool,
  primaryMiddleSchool,
  secondaryHighSchool,
  postsecondaryUndergraduateUniversity,
  collegeOrUniversityGraduateOrAbove,
  negative,
  neutralModeratelyNegative,
  neutralSlightlyNegative,
  neutral,
  neutralSlightlyPositive,
  neutralModeratelyPostive,
  positive
} from './messages'

export function getDisplayAverageGradeLevelLabel(gradeLevelLabel) {
  let displayLabel

  if (gradeLevelLabel === 'elementary_school') {
    displayLabel = primaryElementarySchool
  }

  if (gradeLevelLabel === 'middle_school') {
    displayLabel = primaryMiddleSchool
  }

  if (gradeLevelLabel === 'high_school') {
    displayLabel = secondaryHighSchool
  }

  if (gradeLevelLabel === 'undergraduate') {
    displayLabel = postsecondaryUndergraduateUniversity
  }

  if (gradeLevelLabel === 'university_or_above') {
    displayLabel = collegeOrUniversityGraduateOrAbove
  }

  return displayLabel
}

export function getDisplaySentimentLabel(sentiment) {
  let displayLabel

  if (sentiment === 'Negative') {
    displayLabel = negative
  }

  if (sentiment === 'Neutral (Moderately Negative)') {
    displayLabel = neutralModeratelyNegative
  }

  if (sentiment === 'Neutral (Slightly Negative)') {
    displayLabel = neutralSlightlyNegative
  }

  if (sentiment === 'Neutral') {
    displayLabel = neutral
  }

  if (sentiment === 'Neutral (Slightly Positive)') {
    displayLabel = neutralSlightlyPositive
  }

  if (sentiment === 'Neutral (Moderately Positive)') {
    displayLabel = neutralModeratelyPostive
  }

  if (sentiment === 'Positive') {
    displayLabel = positive
  }

  return displayLabel
}

export function getReadabilityScoresState(scores) {
  let state = ''
  if (Object.keys(scores.stats).length === 0) {
    state = 'updating'
  } else if (
    !scores.stats.average_grade_level ||
    scores.stats.average_grade_level.length === 0
  ) {
    state = 'no-average-grade-level'
  } else {
    state = 'has-average-grade-level'
  }

  return state
}

export function hasReadabilityStats(quest, attributeName) {
  return (
    Boolean(quest.readable_stats) &&
    quest.readable_stats.length > 0 &&
    quest.readable_stats.some(stat => stat.attribute_name === attributeName)
  )
}

export function getSectionScores(quest, subsection) {
  return quest.readable_stats.find(score => score.attribute_name === subsection)
}

export function formatReadingTime(time) {
  return time.replace(/:/g, 'm ').concat('s')
}

export function parseLongestSentenceWordCount(longestSentence) {
  let retVal = {
    wordCount: '',
    longestSentence: ''
  }

  // TODO: Is there a nicer way to to do this????
  retVal.wordCount = longestSentence.split(/\s(.+)/)[0]
  retVal.longestSentence = longestSentence.split(/\s(.+)/)[1].slice(2, -2)
  retVal.longestSentence = `"${
    retVal.longestSentence[0].toUpperCase() + retVal.longestSentence.slice(1)
  }"`
  retVal.longestSentence = retVal.longestSentence.replace(
    /(\s|^)\"([^\"]+)\"/g,
    '$1\u201C$2\u201D'
  )
  return retVal
}

export function formatGradeLevelLabels(label) {
  let formattedLabel = ''
  switch (label) {
    case 'flesch_kincaid_grade_level': {
      formattedLabel = 'Flesch-Kincaid Grade Level'
      break
    }
    case 'gunning_fog_score': {
      formattedLabel = 'Gunning-Fog Score'
      break
    }
    case 'coleman_liau_index': {
      formattedLabel = 'Coleman-Liau Index'
      break
    }
    case 'smog_index': {
      formattedLabel = 'SMOG Index'
      break
    }
    case 'automated_readability_index': {
      formattedLabel = 'Automated Readability Index'
      break
    }
    default: {
      formattedLabel = 'Unknown'
    }
  }

  return formattedLabel
}

export function isMaxOrMinGradeLevel(val, arr) {
  const valuesArray = arr.map(e => {
    return JSON.parse(Object.values(e)[0])
  })
  return (
    JSON.parse(val) === Math.min(...valuesArray) ||
    JSON.parse(val) === Math.max(...valuesArray)
  )
}



// WEBPACK FOOTER //
// ./src/utils/readability.js